import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const getNotInvoicedItems = createAsyncThunk(
  "notInvoiced/getNotInvoicedItems",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/Receivables/NotInvoiced?contact_ID=${id}`
      );
      const data = response?.data;
      return data
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching not invoiced items"
      );
    }
  }
);

export const createInvoice = createAsyncThunk(
  "notInvoiced/createInvoice",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/v1/package/CreateMultiItemInvoice`, payload);
      const data = response?.data;
      onSuccess?.(response);
      return data
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error creating invoice"
      );
    }
  }
);

export const changeInvoiceBuyer = createAsyncThunk(
  "notInvoiced/changeInvoiceBuyer",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/v1/inventory/changeBuyer`, payload);
      const data = response?.data;
      onSuccess?.(response);
      return data
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error Updating Buyer"
      );
    }
  }
);

const notInvoicedSlice = createSlice({
  name: "notInvoiced",
  initialState: {
    data: [],
    error: null,
    loading: false,
    accounts: [],
    updateBuyerLoading: false,
  },
  reducers: {
    updateAccountForItems: (state, action) => {
      const index = state.accounts.findIndex(acc => acc.item_ID === action.payload.item_ID);
      if (index !== -1) {
        // Replace the existing item
        state.accounts[index] = action.payload;
      } else {
        // Add new item
        state.accounts.push(action.payload);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotInvoicedItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotInvoicedItems.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getNotInvoicedItems.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(createInvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(createInvoice.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
       .addCase(changeInvoiceBuyer.pending, (state) => {
        state.updateBuyerLoading = true;
      })
      .addCase(changeInvoiceBuyer.fulfilled, (state) => {
        state.updateBuyerLoading = false;
      })
      .addCase(changeInvoiceBuyer.rejected, (state, action) => {
        state.error = action.payload;
        state.updateBuyerLoading = false;
      });
  },
});

export const { updateAccountForItems } = notInvoicedSlice.actions;

export default notInvoicedSlice.reducer;
